import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { PipesModule } from "../../pipes/pipes.module";
import { DynamicFormQuestionComponent } from "./dynamic-form-question.component";
import { DynamicFormComponent } from "./dynamic-form.component";

@NgModule({
  declarations: [DynamicFormComponent, DynamicFormQuestionComponent],
  imports: [CoreModule, PipesModule],
  exports: [DynamicFormComponent, DynamicFormQuestionComponent],
})
export class DynamicFormModule {}
